import { render, staticRenderFns } from "./PageHead.vue?vue&type=template&id=3ab960d8&scoped=true&"
import script from "./PageHead.vue?vue&type=script&lang=js&"
export * from "./PageHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab960d8",
  null
  
)

export default component.exports